var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alarm-installation"},[_c('al-t2',{attrs:{"title":_vm.title,"alarm":_vm.alarm,"alarmRemote":_vm.alarmRemote,"homepilot":_vm.homepilot,"model":_vm.model,"submodel":_vm.submodel,"step":_vm.step}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }